<template>
  <div>
    <b-tabs class="mb-1">
      <b-tab :title="$t('cancellation.policies')" @click="$router.push('/cancellations/policies')" />
      <b-tab :title="$t('cancellation.product_rules')" active />
      <b-tab :title="$t('cancellation.requests')" @click="$router.push('/cancellations/requests')" />
    </b-tabs>

    <vx-card class="mb-2">
      <small class="text-muted">{{ $t('cancellation.inherit_hint') }}</small>
    </vx-card>

    <Grid
      ref="grid"
      :service="service"
      :hide_actions="true"
      route_name="product_cancellation_rules"
      order_column="id">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="product">{{ $t('cancellation.product') }}</vs-th>
        <vs-th key="policy">{{ $t('cancellation.applied_policy') }}</vs-th>
        <vs-th key="reschedule">{{ $t('cancellation.reschedule') }}</vs-th>
        <vs-th key="origin">{{ $t('cancellation.origin_rule') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div>{{ tr.id }}</div>
          </vs-td>
          <vs-td width="30%" key="product">
            <div>{{ tr.product ? tr.product.name : '—' }}</div>
          </vs-td>
          <vs-td width="35%" key="policy">
            <div>
              {{ policyLabel(tr) }}
              <span v-if="tr.overrides && tr.overrides.fixed_fee">
                · {{ $t('cancellation.fixed_fee') }} {{ formatValue(tr.overrides.fixed_fee) }}
              </span>
            </div>
          </vs-td>
          <vs-td width="15%" key="reschedule">
            <div>{{ rescheduleLabel(tr) }}</div>
          </vs-td>
          <vs-td width="15%" key="origin">
            <vs-chip transparent :color="tr.policy_id || tr.overrides ? 'primary' : 'secondary'" class="text-base">
              {{ tr.policy_id || tr.overrides
                ? $t('cancellation.origin_rule_.override')
                : $t('cancellation.origin_rule_.inherit') }}
            </vs-chip>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { currencyFormatter } from '@/util/Util'

import ProductCancellationRuleService from '@/services/api/ProductCancellationRuleService'

export default {
  components: {
    BTabs,
    BTab
  },
  data: () => ({
    service: null
  }),
  methods: {
    formatValue(value) {
      return currencyFormatter(value)
    },
    policyLabel(rule) {
      if (rule.policy) {
        const version = rule.policy.active_version
        return rule.policy.name + (version ? ` v${version.version}` : '')
      }
      return 'Padrão vigente'
    },
    rescheduleLabel(rule) {
      const overrides = rule.overrides || {}
      if (overrides.pro_rata) return 'Não se aplica'
      if (overrides.reschedule_limit) {
        return `${overrides.reschedule_limit}x até ${overrides.reschedule_min_hours || 12}h antes`
      }
      return 'Segue a política'
    }
  },
  beforeMount() {
    this.service = ProductCancellationRuleService.build(this.$vs)
  }
}
</script>
